import { useState } from "react";
import axios from "axios";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { AreaArquivo, Cartao, Pagina } from "./ui/Painel";
import { CORES } from "../utils/participante";

const ImportarSympla = () => {
  const [arquivo, setArquivo] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState("");

  const handleImportar = async () => {
    if (!arquivo) return;

    setEnviando(true);
    setErro("");
    setResultado(null);

    try {
      const formData = new FormData();
      formData.append("arquivo", arquivo);
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/participantes/importar-sympla`, formData);
      setResultado(data);
      setArquivo(null);
    } catch (error) {
      setErro(error.response?.data?.error || "Erro ao importar convidados do Sympla.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Pagina
      eyebrow="Importações"
      titulo="Importar do Sympla"
      descricao='Envie o PDF "Lista de participantes" exportado do painel do Sympla. Quem já estiver no sistema não é duplicado.'
      largura={720}
    >
      <Cartao titulo="Lista de participantes (PDF)">
        <AreaArquivo
          arquivo={arquivo}
          onArquivo={setArquivo}
          accept="application/pdf"
          rotulo="Selecionar PDF do Sympla"
          dica="Clique ou arraste o arquivo para esta área"
        />

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button variant="contained" onClick={handleImportar} disabled={!arquivo || enviando} sx={{ minWidth: 170 }}>
            {enviando ? <CircularProgress size={20} color="inherit" /> : "Importar convidados"}
          </Button>
        </Box>

        {erro && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {erro}
          </Alert>
        )}

        {resultado && (
          <Box sx={{ mt: 2.5, display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1 }}>
              {[
                ["No PDF", resultado.totalNoPdf],
                ["Importados agora", resultado.importados],
                ["Já existiam", resultado.jaExistiam],
              ].map(([rotulo, valor]) => (
                <Box key={rotulo} sx={{ border: `1px solid ${CORES.borda}`, borderRadius: "8px", px: 1.5, py: 1.25 }}>
                  <Typography sx={{ fontSize: 11.5, color: CORES.textoSuave }}>{rotulo}</Typography>
                  <Typography sx={{ fontSize: 20, fontWeight: 800, color: CORES.navy }}>{valor ?? 0}</Typography>
                </Box>
              ))}
            </Box>
            <Alert severity="success">Importação concluída.</Alert>
          </Box>
        )}
      </Cartao>
    </Pagina>
  );
};

export default ImportarSympla;
